import { render, staticRenderFns } from "./AxxessLteWizard.vue?vue&type=template&id=853c6ba4&"
import script from "./AxxessLteWizard.vue?vue&type=script&lang=js&"
export * from "./AxxessLteWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports